import { schema } from "normalizr";
export const template = new schema.Entity("template");
export const userTemplatesSchema = new schema.Entity("templates", {
  templates: [template]
}, {
  idAttribute: "templateId"
});
export const predefinedTemplatesSchema = new schema.Entity("templates", {
  templates: [template]
}, {
  idAttribute: "templateId"
});